import styled from 'styled-components';
import { BasketFeesDetailsStyled } from '../BasketFeesDetailsStyled';
import { rem } from 'polished';

export const BasketFeesDetailsDS = styled(BasketFeesDetailsStyled)`
    border-color: ${({ theme }) => theme.colors.secondary};

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
    }
  
    .title {
        font-size: ${({ theme }) => theme.fontSizes.h4};
    }

    .summary {
        .item {
            .item-link {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }
        }
    }

    .carteGriseInput {
        .postalCode {
            background: ${({ theme }) => theme.colors.black1};
            border: 1px solid ${({ theme }) => theme.colors.black1};
            color: ${({ theme }) => theme.colors.white};
            border-radius: ${rem(8)};
            &_title {
                font-size: ${({ theme }) => theme.fontSizes.h6};
            }

            &_warning {
                svg {
                    g {
                        path {
                            fill: ${({ theme }) => theme.colors.white};
                        }
                    }
                }
            }

            &_input {
                input {
                    height: ${rem(48)};
                    font-size: ${({ theme }) => theme.fontSizes.h5};
                    width: 70%;
                    margin: 0 ${rem(10)} 0 0;
                    padding: ${rem(5)} ${rem(10)};
                    border-radius: ${rem(3)};
                    border: none;
                    color: ${({ theme }) => theme.colors.black};

                    &.warning {
                        border: 1px solid ${({ theme }) => theme.colors.danger};
                    }
                }

                button {
                    height: ${rem(48)};
                    border-radius: ${rem('24px')};
                    text-transform: unset;
                    font-size: ${({ theme }) => theme.fontSizes.h5};
                    color: ${({ theme }) => theme.colors.black};
                    border-color: ${({ theme }) => theme.colors.black};
                    background: ${({ theme }) => theme.colors.white};
                }
            }
        }
    }
`;
